<template>
  <div class="stations-view">
    <v-container class="my-5">
      <v-card class="mx-auto mb-8" elevation="12" max-width="444">
        <v-carousel
          height="300"
          :show-arrows="false"
          cycle
          hide-delimiter-background
        >
          <v-carousel-item
            v-for="(item, i) in carouselItems"
            :key="i"
            :src="item.src"
            cover
          ></v-carousel-item>
        </v-carousel>
      </v-card>

      <v-row class="ml-1 mb-4">
        <v-col cols="12" sm="12" md="4" lg="3" class="mt-1">
          <v-text-field
            v-model="findTxt"
            hide-details
            outlined
            dense
            clearable
            label="Find Station"
            prepend-inner-icon="mdi-magnify"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="12" md="4" lg="3">
          <v-select
            v-model="freqSelect"
            :items="freqItems"
            label="Frequency Band"
            multiple
            chips
            hide-details
            clearable
            dense
            prepend-inner-icon="mdi-filter-menu"
            :menu-props="{ bottom: true, offsetY: true }"
          >
            <template v-slot:selection="data">
              <v-chip
                :key="JSON.stringify(data.item)"
                v-bind="data.attrs"
                :input-value="data.selected"
                @click:close="freqSelect.splice(freqSelect.indexOf(data.item), 1)"
                close
              >
                {{ data.item }}
              </v-chip>
            </template>
          </v-select>
        </v-col>
        <v-col cols="12" sm="12" md="4" lg="3">
          <v-select
            v-model="satelliteSelect"
            :items="satelliteItems"
            label="Listening Satellite"
            multiple
            chips
            hide-details
            clearable
            dense
            prepend-inner-icon="mdi-filter-menu"
            :menu-props="{ bottom: true, offsetY: true }"
          >
            <template v-slot:selection="data">
              <v-chip
                :key="JSON.stringify(data.item)"
                v-bind="data.attrs"
                :input-value="data.selected"
                @click:close="satelliteSelect.splice(satelliteSelect.indexOf(data.item), 1)"
                close
              >
                {{ data.item }}
              </v-chip>
            </template>
          </v-select>
        </v-col>
      </v-row>

      <v-data-table
        :headers="headers"
        :items="stationsFiltered"
        :search="findTxt"
        class="elevation-1"
        :item-key="station => `${station.name}@${station.userId}`"
        @click:row="navigateToStation"
        :items-per-page="50"
        :footer-props="{
          'items-per-page-options': [25, 50, 100, -1]
        }"
        :loading="loadingStations"
        loading-text="Loading station data..."
        no-data-text="No stations found matching your criteria."
        hover
        :sort-by="['telemetryPackets']"
        :sort-desc="[true]"
      >
        <template v-slot:item.name="{ item }">
          <div :class="getStatusClass(item)">
            <strong>{{ item.name }}</strong>
          </div>
        </template>

        <template v-slot:item.lastSeen="{ item }">
          {{ item.status === 1 ? 'Last Packet:' : 'Last Seen:' }} {{ dateSince(item.lastPacketTime || item.lastSeen) }}
        </template>

        <template v-slot:item.autoTune="{ item }">
          {{ item.autoTune ? item.autoTune + " MHz" : "OFF" }}
        </template>

        <template v-slot:item.test="{ item }">
          {{ item.test ? "ON" : "OFF" }}
        </template>

        <template v-slot:item.telemetryPackets="{ item }">
          {{ item.telemetryPackets.toLocaleString() }}
        </template>

        <template v-slot:item.confirmedPackets="{ item }">
          {{ item.confirmedPackets.toLocaleString() }}
        </template>

          <template v-slot:item.cnt_pckt_tele_433_FSK="{ item }">
       {{ (item.cnt_pckt_tele_433_FSK || 0).toLocaleString() }}
      </template>
       

        
        <template v-slot:item.actions="{ item }">
            <v-btn
                v-if="item.local_ip"
                color="primary"
                class="lighten-1 text-center"
                small
                depressed
                @click.stop="navigateToStation(item)"
            >
                <span>Ground Control</span>
                <v-icon right small>mdi-monitor-dashboard</v-icon>
            </v-btn>
        </template>

      </v-data-table>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import moment from 'moment';

export default {
  name: "Stations",
  data() {
    return {
      findTxt: "",
      satelliteSelect: [],
      satelliteItems: [], // Se llenará desde la API
      freqSelect: [],
      freqItems: ['VHF (137-148 MHz)', 'UHF (400-470 MHz)', 'L-Band (868-915 MHz)', 'S-Band (2.4 GHz)'],
      allStations: [], // Almacenará todas las estaciones de la API
      loadingStations: false,
      headers: [
        { text: 'Station Name', value: 'name', align: 'start', cellClass: 'station-name-cell', class: 'font-weight-bold' },
        { text: 'Listening', value: 'satellite', align: 'start' },
        { text: 'Version', value: 'version', align: 'center' },
        { text: 'Auto Tune', value: 'autoTune', align: 'center' },
        { text: 'Telemetry', value: 'telemetryPackets', align: 'end' },
        { text: 'Frames', value: 'confirmedPackets', align: 'end' },
        { text: 'Telemetry FSK', value: 'cnt_pckt_tele_433_FSK', align: 'end' },
   //     { text: 'Actions', value: 'actions', sortable: false, align: 'center', width: '150px' },
        { text: 'Test Mode', value: 'test', align: 'center' },
        { text: 'Activity', value: 'lastSeen', align: 'start', sortable: false }, // Combinado last packet/last seen
      ],
      carouselItems: [ // Items del carrusel como estaban
        { src: 'https://static.tinygs.com/stationImages/TinyGS_PakalAstroClub_d6102.jpg' },
        { src: 'https://static.tinygs.com/stationImages/TinyGS_exJH3VSR_da535.jpg' },
        { src: 'https://static.tinygs.com/stationImages/TinyGS_EA8DLJ_256B_0b4b6.jpg' },
        { src: 'https://static.tinygs.com/stationImages/TinyGS_RA3TOX_mobile_1ce73.jpg' },
        { src: 'https://static.tinygs.com/stationImages/TinyGS_SQ3DHO_TinyGS_ec1d0.jpg' },
        { src: 'https://static.tinygs.com/stationImages/TinyGS_JL_ESL_01_bc1f1.jpg' },
        { src: 'https://static.tinygs.com/stationImages/TinyGS_OX3HI_1_07d68.jpg' },
      ],
    };
  },
  beforeMount() {
    this.getStations();
    // La paginación ahora es manejada por v-data-table,
    // por lo que la lógica de this.page y $route.query.page no es directamente necesaria
    // a menos que quieras restaurar la página de la tabla desde la URL.
  },
  methods: {
    async getStations() {
      this.loadingStations = true;
      try {
        const { data } = await axios.get(`${process.env.VUE_APP_API_ENDPOINT}/v1/stations`);
        this.allStations = data;
        // Extraer satélites únicos para el filtro
        const uniqueSatellites = [...new Set(data.map(item => item.satellite).filter(s => s))].sort();
        this.satelliteItems = uniqueSatellites;
      } catch (error) {
        console.error("Error fetching stations:", error);
        this.allStations = [];
      } finally {
        this.loadingStations = false;
      }
    },
    navigateToStation(item) {
      this.$router.push(`/station/${item.name}@${item.userId}`);
    },
    dateSince(time) {
      if (!time) { return "Never"; }
      return moment(time).fromNow();
    },
    getStatusClass(station) {
      // Devuelve la clase para el estilo del borde izquierdo en la celda
      return station.status === 1 ? 'online-cell-content' : 'offline-cell-content';
    },
    getFreqRange(selectedFreqItem) {
        // Esta función debe traducir el item de freqItems a un rango [min, max]
        // o a una lógica específica para filtrar station.autoTune
        // Ejemplo (necesitarás ajustarlo a tus datos reales de station.autoTune):
        // station.autoTune suele ser un número como 433.92
        if (selectedFreqItem === 'VHF (137-148 MHz)') return { min: 137, max: 148 };
        if (selectedFreqItem === 'UHF (400-470 MHz)') return { min: 400, max: 470 };
        if (selectedFreqItem === 'L-Band (868-915 MHz)') return { min: 868, max: 915 };
        if (selectedFreqItem === 'S-Band (2.4 GHz)') return { min: 2400, max: 2500 }; // 2.4 GHz = 2400 MHz
        return null;
    }
  },
  computed: {
    stationsFiltered() {
      if (!this.allStations) return [];

      let filtered = [...this.allStations];

      // Filtro por satélite en escucha
      if (this.satelliteSelect.length > 0) {
        filtered = filtered.filter(s => this.satelliteSelect.includes(s.satellite));
      }

      // Filtro por banda de frecuencia
      if (this.freqSelect.length > 0) {
        filtered = filtered.filter(station => {
          if (!station.autoTune) return false; // Si no tiene autoTune, no puede coincidir
          const stationFreq = parseFloat(station.autoTune); // Asegurarse que es un número
          if (isNaN(stationFreq)) return false;

          return this.freqSelect.some(selectedBandName => {
            const range = this.getFreqRange(selectedBandName);
            return range && stationFreq >= range.min && stationFreq <= range.max;
          });
        });
      }
      
      // El filtro findTxt se maneja por la prop :search de v-data-table.
      // Si necesitas un filtrado más específico por campos que no son visibles o
      // con lógica más compleja que un "includes", puedes añadirlo aquí:
      // if (this.findTxt) {
      //   const lowerFindTxt = this.findTxt.toLowerCase();
      //   filtered = filtered.filter(s =>
      //     s.name.toLowerCase().includes(lowerFindTxt) ||
      //     (s.userNotes && s.userNotes.toLowerCase().includes(lowerFindTxt)) // Ejemplo si tuvieras userNotes
      //   );
      // }

      return filtered;
    }
  },
  watch: {
    // v-data-table maneja su propia paginación. Si cambias los filtros,
    // automáticamente se recalculará y mostrará la primera página.
    // findTxt() { this.resetTablePage(); },
    // satelliteSelect() { this.resetTablePage(); },
    // freqSelect() { this.resetTablePage(); },
    // resetTablePage() {
    //   // Si necesitas forzar v-data-table a la página 1 programáticamente:
    //   // this.$refs.stationsTable.page = 1; (necesitarías añadir ref="stationsTable" a v-data-table)
    // }
  }
};
</script>

<style>
/* Estilos copiados y adaptados de Satellites.vue y Station.vue */

/* Estilos para los chips de los filtros (puedes crear clases específicas si es necesario) */
/* .v-chip.VHF { background-color: #2196F3 !important; color: white !important; } */
/* .v-chip.UHF { background-color: #FF9800 !important; color: white !important; } */
/* ... etc. para otras bandas de frecuencia si quieres colores específicos para los chips */


/* Estilo para que la fila de la tabla parezca clickeable */
.v-data-table tbody tr:hover {
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.05) !important;
}

/* Estilos para la celda de nombre de estación con indicador de estado */
.station-name-cell .online-cell-content {
  padding-left: 10px; /* Espacio para el borde */
  border-left: 4px solid green;
}

.station-name-cell .offline-cell-content {
  padding-left: 10px; /* Espacio para el borde */
  border-left: 4px solid red;
}

/* Ajuste para que el contenido dentro de la celda tome el borde, no la celda entera directamente */
/* Esto requiere que el slot :item.name envuelva el contenido en un div con la clase. */
/* Y en <v-data-table> <template v-slot:item.name="{ item }"> <div :class="getStatusClass(item)">...</div> </template> */
/* Y en headers, para la columna 'name', añadir: cellClass: 'station-name-cell' */
/* Esto asegura que el padding y el borde se apliquen correctamente sin afectar otras celdas */

.stations-view .v-chip {
  font-size: 0.8rem;
  height: 28px;
}

.stations-view .v-select .v-chip .v-chip__close {
  font-size: 1rem;
}


</style>